import {PolyBetLine} from "@nolimitcity/slot-game/bin/game/betline/line/PolyBetLine";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Graphics}from "pixi.js";
import {ImmortalFruitsGameConfig} from "../../ImmortalFruitsGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IBetLineWinData, IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ImmortalFruitsBetlineEvent} from "../ImmortalFruitsBetlineEvent";
import {IWinLineConfig} from "../ImmortalFruitsBetlinesView";




export class ImmortalFruitsPolyBetLine extends PolyBetLine {

    private _betlineData:IBetWinData[];
    private _winAmount:PIXI.BitmapText;
    private _winAmountShadow:PIXI.Sprite;
    private _y:number[] = [340, 195, 485, 340, 340];

    constructor(index: number, numberPosition: number[], betLineData: number[], config: IWinLineConfig) {
        super(index, numberPosition, betLineData, config);

        this._winAmountShadow = new PIXI.Sprite(GameResources.getTextures("wheelShadow")[0]);
        this._winAmountShadow.scale.set(0.1);
        this._winAmountShadow.anchor.set(0.5);
        this._winAmount.y = this._y[ index-1] - this._winAmount.height / 2 + 3;
        this._winAmount.pivot.set(0.5);
        this._winAmountShadow.renderable = false;
        this._winAmount.renderable = false;
        //this.addMultiplierEventListeners();
        this.addFeatureEventListeners();
    }
    private addFeatureEventListeners():void {
        EventHandler.addEventListener(this, ImmortalFruitsBetlineEvent.SHOW_WIN_BET_AMOUNT, (event:GameEvent) => this.onShowWinBetLineWin(event.params[0]));
    }

    private showBetLineAmount(withWinAmount:boolean = false){
        const id:number = this.index;
        this._winAmount.renderable = false;
        this._winAmountShadow.renderable = false;
        if(!withWinAmount) {
            return;
        }
        this._betlineData.forEach((item:IBetWinData) => {
            const data:IBetLineWinData = <IBetLineWinData>item;
            if (data.betLineIndex === (id - 1)) {

                this._winAmount.renderable = true;
                this._winAmount.text = (data.multipliedAmount.toFixed(2)).toString();
                this._winAmount.x = (Helper.getSymbolPositions(2, 1)[0]) - this._winAmount.width/2;
                this._winAmount.y = Helper.getSymbolPositions(2, data.betLine[2])[1] - (this._winAmount.height / 2);
                this._winAmountShadow.y = Helper.getSymbolPositions(2, data.betLine[2])[1];
                this._winAmountShadow.renderable = true;
                this._winAmountShadow.alpha = 0.8;
                this._winAmountShadow.anchor.set(0.5);
                this._winAmountShadow.width = this._winAmount.width * 2;
                this._winAmountShadow.height = this._winAmount.height * 3;
                this._winAmountShadow.x = Helper.getSymbolPositions(2, 1)[0] + (this._winAmount.width / 2) - (ImmortalFruitsGameConfig.instance.SYMBOL_WIDTH / 2) + 10;
            }
        });
    }
    private  getLineColor(baseColor:number, lineNumber:number, dynamicColorArr?:number[]):number {
        if(dynamicColorArr)
            return dynamicColorArr[lineNumber! % dynamicColorArr!.length];
        else
            return baseColor * lineNumber!;
    }
    protected showWin(withWinAmount:boolean = false):void {
        super.showWin();
        this._winAmount.text="";
        this._winAmount.renderable =false;
        this._winAmountShadow.renderable =false;


    }

    protected hideAll():void {
        super.hideAll();
    }
    private onShowWinBetLineWin(betlines:any):void {
        this._betlineData = betlines.betwins;
        if(betlines.betlineIndx !== this.index) {
            return;
        }
        this.showWin(true);
        this.showBetLineAmount(true);
    }

    protected showStatic():void {
        this.showWin(false);
        this._winAmount.text="";
        this._winAmount.renderable =false;
        this._winAmountShadow.renderable =false;
    }
    private  drawCircle(radius:number, x:number, y:number, color:number):PIXI.Graphics {
        let circle:PIXI.Graphics = new PIXI.Graphics();

        circle.beginFill(color);
        circle.drawCircle(x, y, radius);
        circle.endFill();

        circle.pivot.set(0.5, 0.5);

        return circle;
    }
    protected draw(numberPosition: number[], betLineData: number[], config: IWinLineConfig): void {

        const linePositions: number[][] = [];
        for (var j = 0; j < betLineData.length; j++) {
            var symId = betLineData[j];
            var basePosition = Helper.getSymbolPositions(j, symId);
            linePositions.push(basePosition);

        }
        // Draw the line.
        let line: Graphics | null = new Graphics();
        let lineWidth: number = 0;

        for (let i: number = 0; i < config.styles.length; i++) {
            const betLineNum = ImmortalFruitsGameConfig.instance.BETLINES.indexOf(this.index);
            this.drawPolylineImmortalFruits(line, config,betLineNum,betLineData);

            lineWidth = Math.max(lineWidth, config.styles[i].lineWidth);
        }

        this.addChild(line);
        this.addChild(this._winAmount);
        StageManager.getLayer(config.staticLineLayer).addChild(this);
        this.alpha = 0;
    }
    private drawPolylineImmortalFruits(line:Graphics, lineConfig:any,lineNumber:number,lineData:any) {

        let outlineThickness:number = lineConfig.lineThickness ? lineConfig.lineThickness : 8;
        let lineThickness:number = outlineThickness * .8;
        let outerCircleLineSize:number = lineConfig.circleSize ? lineConfig.circleSize : lineThickness * .68;
        let innerCircleSize:number = outerCircleLineSize * .75;
        let baseColor:number = lineConfig.baseColor ? lineConfig.baseColor : 0x000000;
        let outlineColor:number = lineConfig.outlineColor ? lineConfig.outlineColor : 0XFFFFFF;
        //if dynamic colors are specified in an array, iterates through color array. otherwise multiplies base color by line number to create different color for each line
        let lineColor:number = lineConfig.dynamicColor ? lineConfig.dynamicColors ? this.getLineColor(baseColor, lineNumber, lineConfig.dynamicColors) : this.getLineColor(baseColor, lineNumber) : baseColor;

        let outlineCont:PIXI.Container = new PIXI.Container();
        this.addChild(outlineCont);
        let circlePos: number[] = Helper.getSymbolPositions(0, lineData[0]);
        if(lineConfig.outlineColor) outlineCont.addChild(this.drawCircle(outerCircleLineSize * .9, circlePos[0] + 1, circlePos[1], outlineColor));
        outlineCont.addChild(this.drawCircle(innerCircleSize * .9, circlePos[0] + 1, circlePos[1], lineColor));


        for (let i: number = 1; i < lineData.length; i++) {
            let circlePos: number[] =Helper.getSymbolPositions(i, lineData[i]);
            if (lineConfig.outlineColor) outlineCont.addChild(this.drawCircle(outerCircleLineSize, circlePos[0], circlePos[1], outlineColor));
            outlineCont.addChild(this.drawCircle(innerCircleSize, circlePos[0], circlePos[1], lineColor));
        }
        for (let i: number = 1; i < lineData.length; i++) {

            let lineFrom: number[] = Helper.getSymbolPositions(i - 1, lineData[i - 1]);
            let lineTo: number[] = Helper.getSymbolPositions(i, lineData[i]);

            if (lineConfig.outlineColor) {
                let lineStroke: PIXI.Graphics = new PIXI.Graphics();
                lineStroke.lineStyle(outlineThickness, outlineColor);
                lineStroke.moveTo(lineFrom[0], lineFrom[1]);
                lineStroke.lineTo(lineTo[0], lineTo[1]);
                outlineCont.addChild(lineStroke);
            }
            line.lineStyle(lineThickness, lineColor);
            line.moveTo(lineFrom[0], lineFrom[1]);
            line.lineTo(lineTo[0], lineTo[1]);

        }


        //this._winAmountShadow.renderable = false;
        //this.addChild(this._winAmountShadow);
        this._winAmount = new PIXI.BitmapText("0", {
            fontName : "betLineFont",
            fontSize : 25,
        });
        this._winAmount.renderable = false;
        this._winAmount.x = ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH / 2;



        this._winAmount.name ="winAmount";

        this._winAmount.tint=lineColor;

    };
}